import { defineStore } from 'pinia';
import { RequestInfo } from '@/types/Request';

export const useRequestStore = defineStore('request', {
  state: (): { 
    requestId: string | null, 
    subId: string | null,
    request: RequestInfo | null 
  } => ({
    requestId: null, 
    subId: null,
    request: null
  }),
  persist: true,
  actions: {
    setRequestIds(requestId: string, subId: string) {
      this.requestId = requestId;
      this.subId = subId;
      console.log('setRequestIds', this.requestId , this.subId);
    },
    clearRequestIds() {
      this.requestId = null;
      this.subId = null;
      console.log('clearRequestIds', this.requestId , this.subId);
    },
    setRequestData(request: RequestInfo) {
      this.request = request;
      console.log('setRequestData', this.request);
    },
    clearRequestData() {
      this.request = null;
      console.log('clearRequestData', this.request);
    },
  },
});